import { memo } from "react";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { format, isValid, parseISO } from "date-fns";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import type { ApplyCoaTemplateEntitySelectionRow } from "../applyCoaTemplateEntitySelection.types";

// Short month + 2-digit year (e.g. "Feb 26"), matching the Figma date columns.
const SHORT_MONTH_YEAR_FORMAT = "MMM yy";

export const ApplyCoaEntityDateCell = memo(
    ({
        row,
        getValue,
    }: CellContext<
        ViewTableFeatures,
        ApplyCoaTemplateEntitySelectionRow,
        string | null
    >) => {
        if (row.original.isClientRow) {
            return <ViewTableCell />;
        }

        const raw = getValue();
        const parsed = raw ? parseISO(raw) : null;
        const label =
            parsed && isValid(parsed)
                ? format(parsed, SHORT_MONTH_YEAR_FORMAT)
                : "-";

        return (
            <ViewTableCell>
                <span className="text-secondary">{label}</span>
            </ViewTableCell>
        );
    },
);
